export function newNoticeId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `n-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function normalizeNoticeRows(rows, { withActive = false } = {}) {
  return (rows || [])
    .map((row, i) => {
      const text = typeof row === "string" ? row : (row?.text || "");
      const item = {
        id: row?.id || newNoticeId(),
        text,
        order: Number.isFinite(Number(row?.order)) ? Number(row.order) : i,
      };
      if (withActive) item.active = row?.active !== false;
      return item;
    })
    .sort((a, b) => a.order - b.order)
    .map((row, i) => ({ ...row, order: i }));
}

export default function QuoteNoticeEditor({
  lines,
  onChange,
  withActive = false,
  addLabel = "문구 추가",
}) {
  const setLines = (next) => onChange(normalizeNoticeRows(next, { withActive }));

  const update = (i, patch) => {
    setLines(lines.map((row, idx) => (idx === i ? { ...row, ...patch } : row)));
  };
  const remove = (i) => setLines(lines.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= lines.length) return;
    const next = [...lines];
    [next[i], next[j]] = [next[j], next[i]];
    setLines(next);
  };
  const add = () => setLines([...lines, { id: newNoticeId(), text: "※ ", active: true }]);

  return (
    <div className="space-y-2" data-testid="quote-notice-editor">
      {lines.map((row, i) => (
        <div key={row.id || i} className="flex gap-2 items-start">
          <span className="text-[10px] text-white/30 w-5 pt-2">{i + 1}</span>
          <textarea
            value={row.text}
            onChange={(e) => update(i, { text: e.target.value })}
            rows={2}
            className="flex-1 bg-white/[0.03] border border-white/10 rounded-lg px-2 py-1.5 text-xs"
          />
          <div className="flex flex-col gap-1 shrink-0">
            <button type="button" onClick={() => move(i, -1)} className="border border-white/10 rounded px-2 py-0.5 text-[10px] text-white/50">위</button>
            <button type="button" onClick={() => move(i, 1)} className="border border-white/10 rounded px-2 py-0.5 text-[10px] text-white/50">아래</button>
            {withActive ? (
              <button
                type="button"
                onClick={() => update(i, { active: row.active === false })}
                className="border border-white/10 rounded px-2 py-0.5 text-[10px] text-white/50"
              >
                {row.active === false ? "비활성" : "활성"}
              </button>
            ) : null}
            <button type="button" onClick={() => remove(i)} className="border border-red-500/20 text-red-300 rounded px-2 py-0.5 text-[10px]">삭제</button>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="text-xs border border-white/15 rounded px-3 py-1.5">{addLabel}</button>
    </div>
  );
}
